// rules/rule-0065-spine-repeat.ts
import { AdjustedLine, ModifierContext } from '../modifier-models';
import { BaseRule } from '../rule-base';

export class Rule0065SpineRepeat extends BaseRule {
    name = '0065 repeat-spine op 75 %';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (!line.modifiers?.includes('0065')) return;

        const newUnits = line.adjustedUnits * 0.75;
        
        if (autoApply) {
            line.adjustedUnits = newUnits;
            line.trace.push('0065 ×0.75');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0065',
                message: '75% reduction for repeat spine operation',
                kind: 'overwrite',
                unitsDelta: newUnits
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext): AdjustedLine[] {
        lines
            .filter(l => l.modifiers?.includes('0065'))
            .forEach(l => {
                l.adjustedUnits *= 0.75;
                l.trace.push('0065 ×0.75');
            });
        return lines;
    }
}
